module.exports = " <div class=vc-search-bar :class=\"{'vc-searchbar-active': focus}\"> <div class=vc-searchbar-input> <input type=search v-el:search @focus=\"this.focus = true\" @blur=\"this.focus = false\" v-model=searchText :placeholder=placeholder> <a href=javascript:; @click.stop=clear() class=vc-searchbar-clear></a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/bars/searchBar.vue
 ** module id = 416
 ** module chunks = 1
 **/